import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../data/testimonials';

const Stars = ({ rating }) => (
  <div className="flex gap-0.5" aria-label={`${rating} out of 5 stars`} data-testid="testimonial-stars">
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} className="w-4 h-4" style={{ color: '#D97904' }} fill={i <= rating ? '#D97904' : 'none'} />
    ))}
  </div>
);

const Testimonials = ({ dark = false, limit = 6, serviceSlug }) => {
  const pool = serviceSlug ? testimonials.filter((t) => t.service === serviceSlug).concat(testimonials.filter((t) => t.service !== serviceSlug)) : testimonials;
  const items = pool.slice(0, limit);
  const avg = (testimonials.reduce((a, t) => a + t.rating, 0) / testimonials.length).toFixed(1);

  return (
    <section id="testimonials" className={`py-20 ${dark ? 'bg-gray-900 text-white' : 'bg-white'}`} data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <p className="text-sm font-bold uppercase tracking-widest mb-3" style={{ color: '#D97904' }}>Client Reviews</p>
            <h2 className={`text-3xl sm:text-4xl lg:text-5xl font-bold ${dark ? 'text-white' : 'text-gray-900'}`} style={{ fontFamily: 'var(--font-serif)' }}>
              Trusted by Northwest Arkansas businesses
            </h2>
          </div>
          <div className={`flex items-center gap-3 ${dark ? 'text-gray-300' : 'text-gray-600'}`} data-testid="testimonials-average">
            <span className="text-4xl font-bold" style={{ color: '#D97904' }}>{avg}</span>
            <div>
              <Stars rating={Math.round(avg)} />
              <p className="text-sm">from {testimonials.length} client reviews</p>
            </div>
          </div>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((t, i) => (
            <figure
              key={t.id}
              data-testid={`testimonial-${t.id}`}
              className={`relative rounded-2xl p-7 border transition-transform duration-300 hover:-translate-y-1 ${
                dark ? 'bg-white/5 border-white/10' : 'bg-gradient-to-br from-white to-orange-50 border-gray-200'
              } ${i % 3 === 1 ? 'lg:translate-y-6' : ''}`}
            >
              <Quote className="w-8 h-8 mb-4 opacity-30" style={{ color: '#D97904' }} />
              <Stars rating={t.rating} />
              <blockquote className={`mt-4 leading-relaxed ${dark ? 'text-gray-200' : 'text-gray-700'}`}>“{t.quote}”</blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                <div className="w-11 h-11 rounded-full flex items-center justify-center font-bold text-white flex-shrink-0" style={{ backgroundColor: '#D97904' }}>
                  {t.name.split(' ').map((n) => n[0]).join('').slice(0, 2)}
                </div>
                <div>
                  <p className={`font-semibold ${dark ? 'text-white' : 'text-gray-900'}`}>{t.name}</p>
                  <p className={`text-sm ${dark ? 'text-gray-400' : 'text-gray-500'}`}>{t.role}, {t.company}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
